import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Ersatzimperfektionsamplitude({ ersatzimperfektionsamplitude = 0 }) {
  const { t } = useTranslation("translation");
  const e_0_Formula = `\\displaystyle e_{\\tiny _{0}} = \\alpha \\cdot \\left(\\overline{\\lambda} - 0,2 \\right) \\cdot \\frac{W_{s}}{A_{s}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.equivalentImperfectionAmplitude")}</p>}
      indicesValue={
        <span>
          e<sub>0</sub>
        </span>
      }
      formulaValue={<ToolTip id={"e_0_Formula"} type={IconType.FORMULA} formula={e_0_Formula} />}
      inputValue={<span className="input">{ConvertToString(ersatzimperfektionsamplitude, 2)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default Ersatzimperfektionsamplitude;
